export type FilterTypes = {
  modelFamily: string[];
  bodyType: string[];
  modelYear: string[];
  trimLine: string[];
  offerType: string[];
  vehicleType: string;
  offerRegion: string[];
  // Internal-only: set by carline URL param, never shown as a filter tag
  modelName?: string[];
};

export type ExposedFiltersTypes = {
  [key: string]: boolean;
};

export const US_FILTERS = ['offerType', 'bodyType', 'modelFamily', 'modelYear'];

export const CA_FILTERS = [
  'vehicleType',
  'modelFamily',
  'bodyType',
  'offerRegion',
  'offerType',
  'modelYear',
];

export const ALL_FILTERS_OPENED: ExposedFiltersTypes = {
  modelFamily: true,
  bodyType: true,
  modelYear: true,
  trimLine: true,
  offerType: true,
  vehicleType: true,
  offerRegion: true,
};

export const ALL_FILTERS_CLOSED: ExposedFiltersTypes = {
  modelFamily: false,
  bodyType: false,
  modelYear: false,
  trimLine: false,
  offerType: false,
  vehicleType: false,
  offerRegion: false,
};

export const INTIAL_FILTERS = {
  modelFamily: [],
  bodyType: [],
  modelYear: [],
  trimLine: [],
  offerType: [],
  vehicleType: 'NEW-CAR',
  offerRegion: ['NAT'],
  modelName: [],
};

export const filtersTypesToRenderWithTypeName = [
  'exteriorColor',
  'interiorColor',
  'wheelSize',
  'price',
  'power',
  'mileage',
  'availableInMonths',
];

export const ACCEPTABLE_URL_PARAMS = [
  'offer-type',
  'carline-group',
  'carline',
  'body-style',
  'trimline',
  'year',
  'type',
  'region',
  'show-details',
];

export const LIST_OF_BODY_TYPES = [
  'suv',
  'sedan',
  'sportback',
  'allroad quattro',
  'avant',
  'coupe',
  'roadster',
  'cabriolet',
  'spyder',
];
